define([
	'internal_util/Logger',
	'internal_util/Util',
	'internal_util/UiUtil',
	'internal_util/ClientUtil',
	'internal_util/StorageUtil',
	'model/ErrorType',
	'model/ActivationType',
	'model/CloudIdentity',
	'model/Origin',
	'model/AuthenticationOption',
	
	'recoverystrategy/ManualRecoveryStrategy',
	
	'factory/AuthenticationOptionGroupsFactory',
	'factory/BindingsFactory',
	'state/UIState',
	'factory/RequestedAttributesFactory',
	'service/UIStateManager',
	'service/EventListenerRegistry',
	'service/FileService',
	'internal_util/Configuration',
	
	'view/ProviderInfoView',
	'view/NavigationView',
	'view/RecoveryStrategyView',
	'view/kiosk/WelcomeView',
	'identity/IdentityButtonView',
	'identity/NoIdentityButtonView',
	'identity/IdentityAttributesView',
	'identity/IdentityAttributesSelectionView',
	'identity/IdentityTransferView',
	'identity/IdentityExportView',
	'identity/IdentityEncryptView',
	'identity/IdentityDecryptView',
	'identity/IdentityDeleteView',
	
	'view/ControlBarView',
	'view/ControlView',
	'view/TextView',
	'view/bindings/ConfirmationView',
	'view/bindings/TransferConfirmationView',
	
	'amdi18n-loader?!state/nls/UIState_strings',
	'amdi18n-loader?!state/nls/IdentityManagementState_strings',
	'amdi18n-loader?!state/nls/IdentitiesOverviewState_strings',
	'amdi18n-loader?!state/nls/IdentityCreationState_strings',
        'amdi18n-loader?!state/nls/BindingState_strings'
], function (
		Logger,
		Util,
		UiUtil,
		ClientUtil,
		StorageUtil,
		ErrorType,
		ActivationType,
		CloudIdentity,
		Origin,
		AuthenticationOption,
		
		ManualRecoveryStrategy,
		
		AuthenticationOptionGroupsFactory,
		BindingsFactory,
		UIState,
		RequestedAttributesFactory,
		UIStateManager,
		EventListenerRegistry,
		FileService,
		Configuration,
		
		ProviderInfoView,
		NavigationView,
		RecoveryStrategyView,
		WelcomeView,
		IdentityButtonView,
		NoIdentityButtonView,
		IdentityAttributesView,
		IdentityAttributesSelectionView,
		IdentityTransferView,
		IdentityExportView,
		IdentityEncryptView,
		IdentityDecryptView,
		IdentityDeleteView,
		
		ControlBarView,
		ControlView,
		TextView,
		ConfirmationView,
		TransferConfirmationView,
		
		CommonStrings,
		Strings,
		OverviewStrings,
		IdentityCreationStrings,
                BindingStrings
		) {
	'use strict';

	/**
	 * IdentityManagementState class
	 */
	function IdentityManagementState(uiStateManager) {
		var npa_auth = {
		    id:"npa",
		    authenticationOptions:[{
			    id:"npa",
			    activation:"eID-Client",
			    type:"http://bsi.bund.de/cif/npa.xml",
			    protocol:"urn:oid:1.3.162.15480.3.0.14",
			    issuer:[
				"O=Bundesrepublik Deutschland, OU=Bundesministerium des Innern, C=DE"],
			    description:"Deutscher Personalausweis",
			    image:{
				url:"https://sp.skidentity.de/management-backend/api/pub/v2/assets/f653b4c4-6089-415a-aadd-11bfb3979316",
				width:"384",
				height:"242"},
			    attributes:[
				{name:"http://www.skidentity.de/att/eIdentifier",value:"",origin:null},
				{name:"http://www.skidentity.de/att/FirstName",value:"",origin:null},
				{name:"http://www.skidentity.de/att/LastName",value:"",origin:null},
				{name:"http://www.skidentity.de/att/Age",value:"",origin:null},
				{name:"http://www.skidentity.de/att/City",value:"",origin:null},
				{name:"http://www.skidentity.de/att/Country",value:"",origin:null},
				{name:"http://www.skidentity.de/att/DateOfBirth",value:"",origin:null},
				{name:"http://www.skidentity.de/att/PlaceOfBirth",value:"",origin:null},
				{name:"http://www.skidentity.de/att/State",value:"",origin:null},
				{name:"http://www.skidentity.de/att/Street",value:"",origin:null},
				{name:"http://www.skidentity.de/att/StreetNumber",value:"",origin:null},
				{name:"http://www.skidentity.de/att/ZipCode",value:"",origin:null},
				{name:"http://www.skidentity.de/att/IDType",value:"",origin:null},
				{name:"http://www.skidentity.de/att/IDAuthProtocol",value:"",origin:null},
				{name:"http://www.skidentity.de/att/IDIssuer",value:"",origin:null}],
			    requestedAttributes:[
				{name:"http://www.skidentity.de/att/eIdentifier",isRequired:true,purpose:null,origins:[]},
				{name:"http://www.skidentity.de/att/FirstName",isRequired:false,purpose:null,origins:[]},
				{name:"http://www.skidentity.de/att/LastName",isRequired:false,purpose:null,origins:[]},
				{name:"http://www.skidentity.de/att/DateOfBirth",isRequired:false,purpose:null,origins:[]},
				{name:"http://www.skidentity.de/att/Street",isRequired:false,purpose:null,origins:[]},
				{name:"http://www.skidentity.de/att/StreetNumber",isRequired:false,purpose:null,origins:[]},
				{name:"http://www.skidentity.de/att/City",isRequired:false,purpose:null,origins:[]},
				{name:"http://www.skidentity.de/att/ZipCode",isRequired:false,purpose:null,origins:[]},
				{name:"http://www.skidentity.de/att/Country",isRequired:false,purpose:null,origins:[]},
				{name:"http://www.skidentity.de/att/PlaceOfBirth",isRequired:false,purpose:null,origins:[]}],
			    derivedCredential:[]}],
		    description:"Deutscher Personalausweis",
		    image:{
			url:"https://sp.skidentity.de/management-backend/api/pub/v2/assets/f653b4c4-6089-415a-aadd-11bfb3979316",
			width:"384",
			height:"242"},
		    attributes:[],requestedAttributes:[
			{name:"http://www.skidentity.de/att/eIdentifier",isRequired:true,purpose:null,origins:[]},
			{name:"http://www.skidentity.de/att/FirstName",isRequired:false,purpose:null,origins:[]},
			{name:"http://www.skidentity.de/att/LastName",isRequired:false,purpose:null,origins:[]},
			{name:"http://www.skidentity.de/att/DateOfBirth",isRequired:false,purpose:null,origins:[]},
			{name:"http://www.skidentity.de/att/Street",isRequired:false,purpose:null,origins:[]},
			{name:"http://www.skidentity.de/att/StreetNumber",isRequired:false,purpose:null,origins:[]},
			{name:"http://www.skidentity.de/att/City",isRequired:false,purpose:null,origins:[]},
			{name:"http://www.skidentity.de/att/ZipCode",isRequired:false,purpose:null,origins:[]},
			{name:"http://www.skidentity.de/att/Country",isRequired:false,purpose:null,origins:[]},
			{name:"http://www.skidentity.de/att/PlaceOfBirth",isRequired:false,purpose:null,origins:[]}]
		};
		
		var auth_req_attr = [
			{name:"http://www.skidentity.de/att/eIdentifier",isRequired:true,purpose:null,origins:[]},
			{name:"http://www.skidentity.de/att/FirstName",isRequired:true,purpose:null,origins:[]},
			{name:"http://www.skidentity.de/att/LastName",isRequired:true,purpose:null,origins:[]},
			{name:"http://www.skidentity.de/att/DateOfBirth",isRequired:true,purpose:null,origins:[]},
			{name:"http://www.skidentity.de/att/Street",isRequired:true,purpose:null,origins:[]},
			{name:"http://www.skidentity.de/att/StreetNumber",isRequired:true,purpose:null,origins:[]},
			{name:"http://www.skidentity.de/att/City",isRequired:true,purpose:null,origins:[]},
			{name:"http://www.skidentity.de/att/ZipCode",isRequired:true,purpose:null,origins:[]}];
		var _uiStateManager,
				_providerInfoView = new ProviderInfoView(),
				_navigationView = new NavigationView(),
				_welcomeView = new WelcomeView(showIdentity),
				_identityButtonView =
				new IdentityButtonView(
						renewIdentity,
						extendIdentity,
						transferIdentity,
						exportIdentity,
						encryptIdentity,
						decryptIdentity,
						enableIdentity,
						disableIdentity,
						deleteIdentity,
						function () {
							_uiStateManager.change('identities_revokation');
						}
						),
				_noIdentityButtonView =
				new NoIdentityButtonView(
				    startAuthWithNPA,
				    function () {
					    StorageUtil.importCloudIdentity(_uiStateManager, showError);
				    },
				    function () {
					    _uiStateManager.change('scan_qr_code');
				    },
				    function () {
					    _uiStateManager.change('identities_revokation');
				    }
				),
				_noIdentityButtonViewMobile = (function () {
					var textView = new TextView();
					return textView;
				})(),
				_noIdentitiesTextView = (function () {
					var textView = new TextView();

					textView.addText(OverviewStrings.no_cloud_identity_available);

					return textView;
				})(),
				_noIdentitiesTextViewMobile = (function () {
					var textView = new TextView();

					textView.addText(OverviewStrings.no_cloud_identity_available_mobile);

					return textView;
				})(),
				_noIdentitiesErrorTextView = (function () {
					var textView = new TextView(true);

					textView.addText(IdentityCreationStrings.invalid_identity_specified);

					return textView;
				})(),
				_allIdentitiesDeletedTextView = (function () {
					var textView = new TextView();

					textView.addText(OverviewStrings.all_cloud_identities_deleted);

					return textView;
				})(),
				_pairing_hello = (function () {
					var textView = new TextView();

					textView.addText("");

					return textView;
				})(),
				_confirmationView = new ConfirmationView(),
				_transferConfirmationView = new TransferConfirmationView(),
				_fido_text = (function () {
					var textView = new TextView();

					textView.addText(Strings.activate_fido);
					textView.addVideo(UiUtil.getImage('FIDO_ANI_MP4').url(), UiUtil.getImage('FIDO_ANI_PNG').url());

					return textView;
				})(),
				_identityAttributesView,
				_identityAttributesSelectionView,
				_identityTransferView = new IdentityTransferView(),
				_identityExportView = new IdentityExportView(doExportIdentity),
				_identityEncryptView = new IdentityEncryptView(doEncryptIdentity),
				_identityDecryptView = new IdentityDecryptView(doDecryptIdentity),
				_identityDeleteView = new IdentityDeleteView(doDeleteIdentity),
				_controlBarView = new ControlBarView('skIdS_control-bar-identity-management'),
				_controlView = new ControlView(extendIdentityWith),
				_saveCheckBox,
				_backButton,
				_nextButton,
				_currentIdentity = null,
				_currentIdentityState = 'unknown',
				_currentCipSession = null,
				_currentAuthenticationOption = null,
				_attributes = null,
				_oneTimeIdentity = false,
				_fromSP = false,
				_renew_cid = false,
				_deletedCloudId = false;

		if (uiStateManager instanceof UIStateManager) {
			_uiStateManager = uiStateManager;

			_identityAttributesView = new IdentityAttributesView(
					_uiStateManager.core().attributesManager(), attributeClick);

			_identityAttributesSelectionView = new IdentityAttributesSelectionView(
					_uiStateManager.core().attributesManager(), doExtendIdentity);
		} else {
			throw new Error('no valid uiStateManager found');
		}

		_saveCheckBox = _controlBarView.addCheckBox(Strings.save_cloud_identity, function (isChecked) {
			_oneTimeIdentity = !isChecked;
		});

		_backButton = _controlBarView.addButton(CommonStrings.back, function () {
			_uiStateManager.core().recoveryStrategyManager().stopRecoveryStrategies();

			if (_fromSP) {
				_uiStateManager.core().cloudIdentitiesManager().deleteCloudIdentity(_currentIdentity, true, function () {
					_uiStateManager.changeContext();
				}, function () {
					_uiStateManager.changeContext();
				});
			} else {
				_uiStateManager.changeContext();
			}
		}, 0);

		_nextButton = _controlBarView.addButton(CommonStrings.next, function () {
			StorageUtil.store('cloud_identity', _currentIdentity.toObject(), true);

			if (_oneTimeIdentity) {
				StorageUtil.store('one_time_identity', true, true);
			} else {
				_uiStateManager.core().cloudIdentitiesManager().addCloudIdentity(_currentIdentity);
			}

			_uiStateManager.changeContext();
		});

//		_controlBarView.addButton(CommonStrings.abort, function () {
//			if (_fromSP) {
//				StorageUtil.remove('authentication_option');
//
//				_uiStateManager.core().cloudIdentitiesManager().deleteCloudIdentity(_currentIdentity, true, function () {
//					_uiStateManager.abort();
//				}, function () {
//					_uiStateManager.abort();
//				});
//			} else {
//				_uiStateManager.abort();
//			}
//		});

		_navigationView.setProgress(1);
	
	UIState.call(this, 'identity_management');


		// private methods
		
		function startAuthWithNPA() {
		    
			var authenticationOption = AuthenticationOptionGroupsFactory.createFromObject(npa_auth);
			
			var requestedAttributes = RequestedAttributesFactory.createFromObject(auth_req_attr);

//			console.info(authenticationOption.toObject());
//			_uiStateManager.core().eidClientManager().startDetection(authenticationOption);

//			var mrs = new ManualRecoveryStrategy(_uiStateManager.core().eidClientManager());
//					
//			mrs.start(authenticationOption);

//			_uiStateManager.change('identity_creation');
			StorageUtil.store("transfer",true,true);
			_uiStateManager.change('privacy_policy', {
				authenticationOption: authenticationOption,
				requestedAttributes: requestedAttributes
			});
//			_uiStateManager.change('activation', {
//				authenticationOption: authenticationOption,
//				requestedAttributes: []
//			});
		}
		
		function showError(error) {
			_controlView.update([], _noIdentitiesErrorTextView);
		}

		function canCreateIdentity() {
			var eidClients = _uiStateManager.core().eidClientManager().eidClients(),
					i;

			if (_currentAuthenticationOption.activation() === ActivationType.BROWSER) {
				return true;
			}

			for (i = 0; i < eidClients.length; i++) {
				if (eidClients[i].supportsPlatform()
						&& eidClients[i].supportsAuthenticationOption(_currentAuthenticationOption)) {
					return true;
				}
			}

			return false;
		}

		function initAttributes(secret, usePVR) {
			
			var binding = _currentIdentity.bindingProtocol()[0];
			binding.setPVR(_currentIdentity.salt(), secret, usePVR);
			
			if(binding.type() === "http://ws.skidentity.de/ci/binding/key/v1.0" && binding.origin() === "FIDO/U2F") {
				_welcomeView.changeContent(_fido_text);
			} else {
				_welcomeView.showLoadingIndicator();
			}

			_navigationView.update(Strings.manage_cloud_identity);
			
			_uiStateManager.core().cloudIdentitiesManager().getCloudIdentityAttributes(_currentCipSession, _currentIdentity, binding, secret, function (result) {
				_currentCipSession = result.session;
				_attributes = result.attributes;
				_currentIdentityState = 'good';

				_welcomeView.hideLoadingIndicator();

				_identityButtonView.update(_currentIdentity, canCreateIdentity(), _currentIdentityState);
				_identityAttributesView.update(_currentIdentity, _currentAuthenticationOption, _attributes, _currentIdentityState);
				_welcomeView.changeContent(_identityAttributesView);

				UiUtil.scrollTo(_identityButtonView.get());
			}, function (error) {
				_welcomeView.changeContent(_identityAttributesView);
				_welcomeView.hideLoadingIndicator();

				_currentCipSession = null;
				_attributes = new Array();

				if (error.type() === ErrorType.RECOVERABLE) {
					_currentIdentityState = error.identityState;
					
					_identityButtonView.update(_currentIdentity, canCreateIdentity(), _currentIdentityState);
					_identityAttributesView.update(_currentIdentity, _currentAuthenticationOption, _attributes, _currentIdentityState, error);
					_welcomeView.changeContent(_identityAttributesView);
				} else {
					_uiStateManager.change('error', error);
				}
			});
		}

		function attributeClick() {
			if (!_currentIdentity.isValid() || _currentIdentityState === 'revoked' ||
					_currentIdentityState === 'expired') {
				renewIdentity();
			} else if (_currentIdentity.isEncrypted()) {
				_navigationView.update(Strings.insert_pin);

				var binding = _currentIdentity.bindingProtocol()[0];
				var identityDecryptView;
			
				_uiStateManager.core().cloudIdentitiesManager().usePVRForGetCloudIdentityAttributes(function(usePVR) {
					if(binding.type() === "http://ws.skidentity.de/ci/binding/key/v1.0" && binding.origin() === "FIDO/U2F") {
						if (!usePVR) {
							initAttributes(null, usePVR);
						} else {
							identityDecryptView = new IdentityDecryptView(function (secret) {
								initAttributes(secret, usePVR);
							});
							identityDecryptView.update();
							_welcomeView.changeContent(identityDecryptView);
						}
					} else {
						identityDecryptView = new IdentityDecryptView(function (secret) {
							initAttributes(secret, usePVR);
						});
						identityDecryptView.update();
						_welcomeView.changeContent(identityDecryptView);
					}
				}, function(error){
					identityDecryptView = new IdentityDecryptView(function (secret) {
						initAttributes(secret, false);
					});
					identityDecryptView.update();
					_welcomeView.changeContent(identityDecryptView);
				});
			}
		}

		function showIdentity() {
			_uiStateManager.messageBrokerManager().close();
			if (_currentIdentity === null) {
				_navigationView.update(Strings.no_cloud_identity_available);
				_welcomeView.changeContent(_controlView);
				_controlView.update([], _noIdentitiesTextView);
			} else {
				if (_currentIdentity.isEncrypted()) {
					_navigationView.update(Strings.manage_cloud_identity);

					_identityButtonView.update(_currentIdentity, canCreateIdentity(), _currentIdentityState);
					_identityButtonView.removeActiveStates();
					_identityAttributesView.update(_currentIdentity, _currentAuthenticationOption, _attributes, _currentIdentityState);
					_welcomeView.changeContent(_identityAttributesView);
				} else {
					_navigationView.update(Strings.manage_cloud_identity);

					_identityButtonView.update(_currentIdentity, canCreateIdentity(), _currentIdentityState);
					_identityButtonView.removeActiveStates();

					if (_attributes === null || _attributes.length === 0) {
						initAttributes(null);
					} else {
						_identityAttributesView.update(_currentIdentity, _currentAuthenticationOption, _attributes, _currentIdentityState);
						_welcomeView.changeContent(_identityAttributesView);
					}
				}
			}
		}

		function updateIdentity(requestedAttributes) {

			_welcomeView.showLoadingIndicator();
			
			var activationData = {
					authenticationOption : _currentAuthenticationOption,
					requestedAttributes : requestedAttributes,
					identity : _currentIdentity,
					secret : null
				};
			
			_uiStateManager.change('activation', activationData);
		}

		function renewIdentity() {
			_uiStateManager.messageBrokerManager().close();
			_navigationView.update(Strings.renew_cloud_identity);

			updateIdentity(RequestedAttributesFactory.createFromAttributeIdentifiers(_currentIdentity.attributeIdentifiers()));
		}

		function extendIdentity() {
			_uiStateManager.messageBrokerManager().close();
			_navigationView.update(Strings.extend_cloud_identity);

			RequestedAttributesFactory.createFromAttributeIdentifiers(_currentIdentity.attributeIdentifiers());

			_identityAttributesSelectionView.update(
					_currentAuthenticationOption,
					uiStateManager.core().cloudIdentitiesManager().requestedAttributes(),
					_currentIdentity,
					null,
					true);

			//_identityView.changeContent(_identityAttributesSelectionView);
			_controlView.update(filterAuthenticationOptions(uiStateManager.core().cloudIdentitiesManager().getUsableAuthenticationOptions()), Strings.no_usable_identity_available);
			_welcomeView.changeContent(_controlView);
		}

		function extendIdentityWith(authenticationOption) {
			var data = {
				authenticationOption: authenticationOption,
				requestedAttributes: _uiStateManager.core().cloudIdentitiesManager().requestedAttributes()
			};
			//TODO: check authopt for eID-Client etc
			//TODO: change view to recoverystrategy if eID-Client
			_identityAttributesSelectionView.update(
					authenticationOption,
					uiStateManager.core().cloudIdentitiesManager().requestedAttributes().concat(authenticationOption.requestedAttributes()),
					_currentIdentity,
					null,
					true);
			_welcomeView.changeContent(_identityAttributesSelectionView);
			//_uiStateManager.change('attributes_selection', data);
		}

		function filterAuthenticationOptions(authenticationOptions) {
			var eidClients = _uiStateManager.core().eidClientManager().supportedEidClients(),
					filteredAuthenticationOptions = new Array(),
					i, j;

			for (i = 0; i < authenticationOptions.length; i++) {
				if (authenticationOptions[i].cloudID() || authenticationOptions[i].activation() === ActivationType.BROWSER) {
					filteredAuthenticationOptions.push(authenticationOptions[i]);
				} else {
					for (j = 0; j < eidClients.length; j++) {
						if (eidClients[j].supportsAuthenticationOption(authenticationOptions[i])) {
							filteredAuthenticationOptions.push(authenticationOptions[i]);
							break;
						}
					}
				}
			}

			return filteredAuthenticationOptions;
		}

		//TODO: add new credentials
		function doExtendIdentity(selectedAttributeNames) {
			var requestedAttributes = uiStateManager.core().cloudIdentitiesManager().requestedAttributes(),
					selectedAttributes = new Array(),
					i, j;

			//FIXME: Attributes dosen't get added
			for (i = 0; i < selectedAttributeNames.length; i++) {
				for (j = 0; j < requestedAttributes.length; j++) {
					if (selectedAttributeNames[i] === requestedAttributes[j].name()) {
						selectedAttributes.push(requestedAttributes[j]);
						break;
					}
				}
			}

			updateIdentity(selectedAttributes);
		}

		function transferIdentity() {
			_transferConfirmationView.setCallback(function() {
				StorageUtil.store("transfer",true,true);
				renewIdentity();
			});
			_welcomeView.changeContent(_transferConfirmationView);
		}
		
		function pair(url) {
			try{
				_uiStateManager.messageBrokerManager().open(function(message) {
					_welcomeView.showLoadingIndicator();
					switch(message.typ){
						case "Closed":
							//TODO
							_welcomeView.hideLoadingIndicator();
							break;
						case "Hello":
							_welcomeView.hideLoadingIndicator();
							_confirmationView.setRemoteAddr(message.adr);
                                                        _confirmationView.setInfoText(BindingStrings.please_compare_second);
							_confirmationView.setVisualConfimation(message.txt);
                                                        _navigationView.update(BindingStrings.compare_code);
							_welcomeView.changeContent(_confirmationView);
							break;
					}
				}, url);
			}catch(e){
				console.error(e);
			}
		}

		function exportIdentity() {
			_uiStateManager.messageBrokerManager().close();
			_navigationView.update(Strings.export_cloud_identity);

			_welcomeView.changeContent(_identityExportView);
		}

		function doExportIdentity() {
			var fileName = _currentAuthenticationOption.description() + '.cloud_id';

			fileName = fileName.replace(/\s+/g, '_');

			FileService.download(fileName, JSON.stringify(_currentIdentity.toObject()));
		}

		function encryptIdentity() {
			_uiStateManager.messageBrokerManager().close();
			_navigationView.update(Strings.encrypt_cloud_identity);

			_identityEncryptView.update();

			_welcomeView.changeContent(_identityEncryptView);
		}

		function doEncryptIdentity(secret) {
			_welcomeView.showLoadingIndicator();
			
			var salt = Util.randomString();

			_uiStateManager.core().cloudIdentitiesManager().issueCloudIdentity(_currentCipSession, _currentIdentity, null, secret, salt, function (result) {
				var oldIdentity = _currentIdentity;
				_currentCipSession = result.session;
				_currentIdentity = result.identity;
				_uiStateManager.core().cloudIdentitiesManager().deleteCloudIdentity(oldIdentity, true, function () {
					_welcomeView.hideLoadingIndicator();

					showIdentity();

					// save cloudid in local storage
					_uiStateManager.core().cloudIdentitiesManager().addCloudIdentity(_currentIdentity);

					UiUtil.scrollTo(_identityButtonView.get());
				});
			}, function (error) {
				_currentCipSession = null;

				_welcomeView.hideLoadingIndicator();

				if (error.type() === ErrorType.RECOVERABLE) {
					_identityEncryptView.update();
					_identityEncryptView.showError(error.data());
				} else {
					_uiStateManager.change('error', error);
				}
			});
		}

		function decryptIdentity() {
			_uiStateManager.messageBrokerManager().close();
			_navigationView.update(Strings.decrypt_cloud_identity);

			_identityDecryptView.update();

			_welcomeView.changeContent(_identityDecryptView);
		}

		function doDecryptIdentity(secret) {
			_welcomeView.showLoadingIndicator();

			_uiStateManager.core().cloudIdentitiesManager().issueCloudIdentity(null, _currentIdentity, secret, null, null, function (result) {
				var oldIdentity = _currentIdentity;
				_currentCipSession = result.session;
				_currentIdentity = result.identity;
				_uiStateManager.core().cloudIdentitiesManager().deleteCloudIdentity(oldIdentity, true, function () {
					_welcomeView.hideLoadingIndicator();

					showIdentity();

					// save cloudid in local storage
					_uiStateManager.core().cloudIdentitiesManager().addCloudIdentity(_currentIdentity);

					UiUtil.scrollTo(_identityButtonView.get());
				});
			}, function (error) {
				_currentCipSession = null;

				_welcomeView.hideLoadingIndicator();

				if (error.type() === ErrorType.RECOVERABLE) {
					_identityDecryptView.update();
					_identityDecryptView.showError(error.data());
				} else {
					_uiStateManager.change('error', error);
				}
			});
		}

		function enableIdentity() {
			_uiStateManager.messageBrokerManager().close();
			_welcomeView.showLoadingIndicator();

			_uiStateManager.core().cloudIdentitiesManager().enableCloudIdentity(_currentIdentity, function () {
				_welcomeView.hideLoadingIndicator();

				_welcomeView.changeImageAppearance(_currentIdentity);

				showIdentity();
			});
		}

		function disableIdentity() {
			_uiStateManager.messageBrokerManager().close();
			_welcomeView.showLoadingIndicator();

			_uiStateManager.core().cloudIdentitiesManager().disableCloudIdentity(_currentIdentity, function () {
				_welcomeView.hideLoadingIndicator();

				_welcomeView.changeImageAppearance(_currentIdentity);

				showIdentity();
			});
		}

		function deleteIdentity() {
			_uiStateManager.messageBrokerManager().close();
			_navigationView.update(Strings.delete_cloud_identity);

			_identityDeleteView.update(_currentIdentityState);

			_welcomeView.changeContent(_identityDeleteView);
		}

		function doDeleteIdentity(revokeCloudIdentity) {
			_welcomeView.showLoadingIndicator();

			_uiStateManager.core().cloudIdentitiesManager().deleteCloudIdentity(_currentIdentity, revokeCloudIdentity, function () {
				_currentIdentity = null;
				_currentCipSession = null;

				_welcomeView.hideLoadingIndicator();

				_uiStateManager.change('identities_overview',{deletedCloudId: true});
			}, function (error) {
				_welcomeView.hideLoadingIndicator();

				if (error.type() === ErrorType.RECOVERABLE) {
					_uiStateManager.change('identities_overview',{deletedCloudId: true});
				} else {
					_uiStateManager.change('error', error);
				}
			});
		}


		// public methods

		this.title = function () {
			return _uiStateManager.core().cloudIdentitiesManager().providerInfo().description();
		};
		
		this.poweredByImage = function () {
			if (_uiStateManager.core().optionsManager() === null || _uiStateManager.core().optionsManager() === undefined) {
				return null;
			}
			return _uiStateManager.core().optionsManager().providerInfo().poweredByImage();
		};

		this.content = function () {
			return [_providerInfoView, _navigationView, _welcomeView];
		};

		this.controls = function () {
			return _controlBarView;
		};

		this.enter = function (doneCallback, identityData) {
			var origin = null,
				secret = identityData.hasOwnProperty('secret') ? identityData['secret'] : null;
				_currentIdentity = identityData.hasOwnProperty('identity') ? identityData['identity'] : null;
				_currentCipSession = identityData.hasOwnProperty('flow-id') ? identityData['flow-id'] : null;
				_fromSP = identityData.hasOwnProperty('fromSP') ? identityData['fromSP'] : false;
				_renew_cid = identityData.renew ? identityData.renew : false;
				_deletedCloudId = identityData.deletedCloudId ? identityData.deletedCloudId : false;
			
			if (_currentIdentity !== null) {
				origin = _currentIdentity.origin();
			}
			if (origin === null) {
				// fallback to cloudid option (which should always be present)
				origin = new Origin('http://ws.skidentity.de/ci/v2.0', 'http://ws.skidentity.de/ci/v2.0', []);
			}
			
			// determine current authentication option
			_currentAuthenticationOption = _uiStateManager.core().cloudIdentitiesManager()
					.getAuthenticationOptionForOrigin(origin);

			_navigationView.update(Strings.manage_cloud_identity);
			if(_uiStateManager.core().contextChangeable()) {
			    _providerInfoView.update(_uiStateManager.core().optionsManager().providerInfo());
			} else {
			    _providerInfoView.update(_uiStateManager.core().cloudIdentitiesManager().providerInfo());
			}
			_welcomeView.update(_currentIdentity, _currentAuthenticationOption);

			if (_uiStateManager.core().contextChangeable()) {
				_backButton.show();
			} else {
				_backButton.hide();
			}

			if (_fromSP) {
				_saveCheckBox.children('input').prop('checked', true);

				_saveCheckBox.show();
				_nextButton.show();
			} else {
				// TODO: this deletes all existing identities; they should be revoked before deletion
				_uiStateManager.core().cloudIdentitiesManager().addCloudIdentity(_currentIdentity);

				_identityButtonView.update(_currentIdentity, canCreateIdentity(), _currentIdentityState);
				_identityButtonView.removeActiveStates();

				_welcomeView.changeButtons(_identityButtonView);

				_saveCheckBox.hide();
				_nextButton.hide();
			}

			if (_currentIdentity === null) {
				_navigationView.update(OverviewStrings.no_cloud_identity_available);
				_welcomeView.enableTooltip(OverviewStrings.no_cloud_identity_available);

				_welcomeView.changeButtons(_noIdentityButtonView);

				_controlView.update([], _noIdentitiesTextView);
				
				if (ClientUtil.isMobileClient()){
				    _welcomeView.changeButtons(_noIdentityButtonViewMobile);
				    _controlView.update([], _noIdentitiesTextViewMobile);
				}

				_welcomeView.changeContent(_noIdentityButtonView);
				//TODO: pvr / binding for attr-view
			} else if (_currentIdentity.isEncrypted() && secret === null) {
				_attributes = null;

				_navigationView.update(Strings.manage_cloud_identity);

				_identityButtonView.update(_currentIdentity, canCreateIdentity(), _currentIdentityState);
				_identityButtonView.removeActiveStates();
				_identityAttributesView.update(_currentIdentity, _currentAuthenticationOption, _attributes, _currentIdentityState);
				_welcomeView.changeContent(_identityAttributesView);
			} else {
				initAttributes(secret);
			}
			
			if (_renew_cid && !_currentIdentity.isValid()) {
				StorageUtil.store('renew_cid', _renew_cid, true);
				renewIdentity();
			} else if (_renew_cid) {
				_uiStateManager.changeContext();
			}
			
			if (_deletedCloudId) {
				_controlView.update([], _allIdentitiesDeletedTextView);
			}
			
			if (identityData.hasOwnProperty('pair')) {
				_welcomeView.changeButtons(_pairing_hello);
                                _navigationView.update(BindingStrings.compare_code);
				pair(identityData['pair']);
			}
			
			var transfer = StorageUtil.read("transfer");
			if (transfer) {
				//Tranfser was abort -> deleting the flag
				StorageUtil.remove("transfer");
			}

			Util.callCallbacks(doneCallback);
			
			startAuthWithNPA();
		};

		this.leave = function (doneCallback) {
			_currentIdentity = null;
			_currentCipSession = null;
			_currentAuthenticationOption = null;
			_attributes = null;
			_oneTimeIdentity = false;

			_welcomeView.hideLoadingIndicator();
			_identityButtonView.hideButtonMenu();

			Util.callCallbacks(doneCallback);
		};
	}
	;

	IdentityManagementState.prototype = Object.create(UIState.prototype);

	return IdentityManagementState;
});


//////////////////
// WEBPACK FOOTER
// ./src/main/web/js/app/state/IdentityManagementState.js
// module id = 330
// module chunks = 3